/**
 * The app version
 *
 * This file is generated by a build script. Do not directly change.
 */
export const appVersion = '1.484.0';
